(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/spelpaus-react/assets/react/pages/svs-suspension/components/approve-information.js') >= 0) return;  svs.modules.push('/modules/spelpaus-react/assets/react/pages/svs-suspension/components/approve-information.js');
'use strict';

const ApproveInformation = () => {
  const gamingPauseDoc = ReactRedux.useSelector(state => state.suspension.gamingPauseDoc);
  const personalInformationDoc = ReactRedux.useSelector(state => state.suspension.personalInformationDoc);
  return React.createElement("div", {
    className: "padding-xs-top-1 align-left"
  }, "Genom att klicka p\xE5 \"Pausa\" godk\xE4nner du", ' ', React.createElement("a", {
    className: "u-text-decoration-underline",
    href: gamingPauseDoc === null || gamingPauseDoc === void 0 ? void 0 : gamingPauseDoc.url,
    rel: "noreferrer",
    target: "_blank"
  }, "Villkoren f\xF6r spelpaus"), ' ', "samt intygar att du tagit del av", ' ', React.createElement("a", {
    className: "u-text-decoration-underline",
    href: personalInformationDoc === null || personalInformationDoc === void 0 ? void 0 : personalInformationDoc.url,
    rel: "noreferrer",
    target: "_blank"
  }, "Svenska Spels information om behandling av personuppgifter"), ".");
};
svs.spelpaus.pages.svsSuspension.components.ApproveInformation = ApproveInformation;

 })(window);